import { NextPimField } from '../Catalog/NextPimField';

export class SearchForm {

  constructor(
    public id?: string,
    public userId?: string,
    public name?: string,
    public filterCondition?: string,
    public indexState?: string,
    public searchOptions?: SearchFormOptionItem[],
  ) {
  }
}


export class SearchFormOptionItem {

  constructor(
    public order?: number,
    public nextPimField?: NextPimField,
    public operator?: string,
    public dataType?: string,
    public values?: string[],
    public value?: any,
    public valueTo?: any,
  ) {
  }
}
